import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { S25PricingModule } from "../../s25.pricing.module";
import { PaymentsStore } from "./s25.payments.store";
import { PricingStore } from "../s25.event.pricing.store";

/**
 * The FreshBooks export controls for one organization. FreshBooks is on its way out, so this
 * adapts the existing component to the refactored page rather than reimplementing it.
 */
@TypeManagerDecorator("s25-ng-pricing-freshbooks")
@Component({
    selector: "s25-ng-pricing-freshbooks",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25PricingModule],
    template: `
        @if (!invoicesLoading()) {
            <s25-ng-invoice
                [s25Invoices]="invoices()"
                [orgId]="orgId()"
                [eventId]="eventId()"
                [billId]="evBillId()"
                [hasRelatedEvents]="hasRelatedEvents()"
                [showOrgSummary]="false"
                (refreshInvoices)="refresh()"
            />
        }
    `,
    host: { class: "pricing-freshbooks" },
    styles: `
        :host {
            display: block;
            padding: 0.75rem 1.25rem;
            border: 1px solid var(--color--table-border);
        }

        :host ::ng-deep .S25Invoice > button.c-textButton {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0;
            font: inherit;
            font-weight: 600;
        }

        :host ::ng-deep .S25Invoice > button.c-textButton,
        :host ::ng-deep .S25Invoice > button.c-textButton:hover,
        :host ::ng-deep .S25Invoice > button.c-textButton:focus {
            color: var(--color--text) !important;
        }

        :host ::ng-deep .S25Invoice > button.c-textButton:focus-visible {
            outline-offset: 4px;
        }
    `,
})
export class S25PricingFreshbooksComponent {
    private readonly paymentsStore = inject(PaymentsStore);
    private readonly pricingStore = inject(PricingStore);

    readonly orgId = input.required<number>();

    protected readonly invoices = this.paymentsStore.fbInvoiceData;
    protected readonly invoicesLoading = this.paymentsStore.fbInvoicesLoading;
    protected readonly eventId = computed(() => this.pricingStore.eventId() ?? 0);
    protected readonly evBillId = computed(() => this.pricingStore.evBillId() ?? 0);
    protected readonly hasRelatedEvents = computed(() => this.pricingStore.eventIds().length > 1);

    protected async refresh() {
        await this.paymentsStore.reloadFreshbooks();
        await this.pricingStore.reloadInvoices();
    }
}
